<script>
import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
import {register} from 'swiper/element/bundle';

register();

gsap.registerPlugin(SplitText)

export default {
  name: "EventStep1",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    isMap: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isMap(newVal) {
      if (newVal === true) {
        this.$nextTick(() => {
          this.getAvatar(this.formData.avatar);
        });
      }
    },
  },
  data() {
    return {
      popupWidth:null,
      swiperContainer: null,
      selectedImage: null
    }
  },
  beforeMount() {
    this.getAvatar(this.formData.avatar);
    this.$emit('goBack', 1);
    this.popupWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    this.popupWidth = this.popupWidth * 0.9 - 60;

  },
  mounted() {
    this.initAnimation();
  },
  methods: {
    getAvatar(avatar) {
      this.selectedImage = require(`@/assets/img/avatare/${avatar}.webp`);
    },
    launchTimeStep1() {
      this.$emit('nextStep', 'eventStep2');
    },
    eventStep1() {
      this.$emit('nextStep', 'eventStep1');
    },
    playVideo(data) {
      this.$emit('videoData', {step: 'eventStep2', video: data});
    },
    closeOverlay() {
      this.$emit('closeOverlay')
    },
    nextStep(data) {
      this.$emit('nextStep', data)
    },
    initAnimation() {

      var mySplitText = new SplitText(this.$refs.speechbubble_anim.children, {type: "words"});
      var splitTextTimeline = gsap.timeline();
      mySplitText.split({type: "chars, words"})
      splitTextTimeline
          .from(mySplitText.chars, {
            duration: 0.6,
            // display:"none",
            visibility: "hidden",
            stagger: 0.016
          })
          .from(this.$refs.launchtime_content__figurewrapper.children, {
            stagger:0.25,
            autoAlpha:0,
            y:100
          });
    },

  }
}
</script>

<template>
  <div ref="smallPopup" id="sidebarpopup" class="popup overlay smallerpopup"
       data-model="">
    <div ref="popup_wrapper__smaller" class="popup_wrapper popup_wrapper__smaller">
               <span @click="closeOverlay" class="popup_closepopup closeoverlay">
<svg xmlns="http://www.w3.org/2000/svg" width="22.945" height="22.945" viewBox="0 0 22.945 22.945">
  <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
    <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)" fill="none" stroke="#fff"
          stroke-linecap="round" stroke-width="2"/>
    <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117" transform="translate(20.117 0) rotate(90)"
          fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
</span>
      <span @click="nextStep(1)" class="popup_prevstep prevstep">
        <img style="transform: scaleX(-1);" src="@/assets/img/arrow-right.svg">
      </span>
      <div class="popup_content popup_content_right">
        <div ref=""  class="popup_content launchtime_contentwrapper">
          <div ref="launchTime" class="form-content launchtime_content" style="">
            <div>
              <div class="herowrapper">
                <img src="@/assets/img/female.png"/>
                <img src="@/assets/img/male.png"/>
                <img src="@/assets/img/gedankenblase.png"/>
              </div>
              <div ref="speechbubble_anim" class="launchtime_content__textwrapper form-content introcontent">
                <p class="speechbubble_anim">{{ $t('takeaBreak.breakEvents_intro')}}</p>
              </div>
            </div>
            <div v-show="popupWidth > 768" ref="launchtime_content__figurewrapper" class="launchtime_content__figurewrapper">
              <div>
                <figure @click="playVideo('bar')">
                  <img src="@/assets/img/activity/bar.png"/>
                  <figcaption>
                    {{ $t('takeaBreak.breakEvents_event1')}}

                  </figcaption>
                  <img class="avatarthumb" :src="selectedImage"/>
                </figure>
              </div>
              <div>
                <figure @click="playVideo('konzert')">
                  <img src="@/assets/img/activity/konzert.png"/>
                  <figcaption>
                    {{ $t('takeaBreak.breakEvents_event2')}}
                  </figcaption>
                  <img class="avatarthumb" :src="selectedImage"/>
                </figure>
              </div>
              <div>
                <figure @click="playVideo('kirmes')">
                  <img src="@/assets/img/activity/kirmes.png"/>
                  <figcaption>
                    {{ $t('takeaBreak.breakEvents_event3')}}
                  </figcaption>
                  <img class="avatarthumb" :src="selectedImage"/>
                </figure>
              </div>
            </div>
            <swiper-container v-show="popupWidth <= 768" class="swipercontainer launchtime_content__figurewrapper"
                              ref="swiperContainer"
                              :slide-to-clicked-slide="true"
                              :slides-per-view="1"
                              :width="this.popupWidth"
                              :centered-slides="true"
                              :initialSlide="0"
                              :injectStyles="[
                                  '.swiper-button-next,.swiper-button-prev {color:#005672;}'
                                  ]"
                              :autoHeight="true"
                              :navigation="{
                                enabled:true
                              }"
                              :pagination="{
                                hideOnClick: false,
                                clickable:true
                              }"


                              @swiperprogress="onProgress"
                              @swiperslidechange="onSlideChange"
                              @swiperactiveindexchange="onActiveIndexChange"
                              @swiperclick="onClick"
                              @swiperafterInit="afterInit"
            >


              <swiper-slide>
                <div>
                  <figure @click="playVideo('bar')">
                    <img src="@/assets/img/activity/bar.png"/>
                    <figcaption>
                      {{ $t('takeaBreak.breakEvents_event1')}}
                    </figcaption>
                    <img class="avatarthumb" :src="selectedImage"/>
                  </figure>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div>
                  <figure @click="playVideo('konzert')">
                    <img src="@/assets/img/activity/konzert.png"/>
                    <figcaption>
                      {{ $t('takeaBreak.breakEvents_event2')}}
                    </figcaption>
                    <img class="avatarthumb" :src="selectedImage"/>
                  </figure>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div>
                  <figure @click="playVideo('kirmes')">
                    <img src="@/assets/img/activity/kirmes.png"/>
                    <figcaption>
                      {{ $t('takeaBreak.breakEvents_event3')}}
                    </figcaption>
                    <img class="avatarthumb" :src="selectedImage"/>
                  </figure>
                </div>
              </swiper-slide>
            </swiper-container>
          </div>

        </div>
      </div>
    </div>
  </div>


</template>

<style>


</style>

<style lang="scss" scoped>

</style>
